module.exports = __webpack_public_path__ + "assets/ae6a7aea8645e81ce1ef6fb6215a43f4.svg";